export const getKey = (pre) => {
  return `${pre}_${new Date().getTime()}`;
};
